import { useAppContext } from '../../providers';
import { useAppDispatch } from '../../providers/AppProvider/AppProvider';
import * as types from '../../providers/AppProvider/types';

/**
 * Hook for getting / setting the selected resource with persistence
 * @returns {{selectedResource: string, setSelectedResource: (payload: string) => void}}
 */
export const useSelectedResource = () => {
  const dispatch = useAppDispatch();
  const { selectedResource } = useAppContext();

  /**
   * Set the selected resource and persist it
   * @param {string} payload - The resource identifier to select
   */
  const setSelectedResource = (payload) => {
    dispatch({ type: types.SELECTED_RESOURCE, payload });
    localStorage.setItem(types.SELECTED_RESOURCE, payload);
  };

  return {
    selectedResource,
    setSelectedResource,
  };
};
